import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import moment from 'moment';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {addInvoiceToSelected, getInvoiceDetail} from '../../actions/InvoiceActions';
import {
  calculateUnitPrice,
  formatTotal,
  formatColumn,
  removePreceedingZero,
  getCurrency,
  formatMoney
} from '../../common/invoiceHelpers';
import {trimLeadingZeroes} from "../../utils";
import {canMakePayment} from "../../PermissionSelectors";
import {isCredit} from "./InvoiceList";
import {faAngleLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      billingDocumentNumber: '',
      documentDate: '',
      totalAmount: '',
      currencyKey: '',
      customerAddress: '',
      invoiceRecipientAddress: '',
      backPage: '/invoices',
    };
    this.goBack = this.goBack.bind(this);
    this.pay = this.pay.bind(this);
  }

  pay(invoice) {
    this.props.dispatch(addInvoiceToSelected(invoice));
    this.props.history.push("/invoices/pay");
  }

  goBack() {
    this.props.history.goBack();
  }

  componentDidMount() {
    const docNumber = this.props.match.params.billingDocumentNumber;

    if (docNumber) {
      getInvoiceDetail(this.props.dispatch, docNumber, '01').then((result) => {
        if (result) {
          if (result.header_data) {
            this.setState({billingDocumentNumber: result.header_data.billing_document_number ? result.header_data.billing_document_number : ''});
            this.setState({billingDocumentType: result.header_data.billing_document_type ? result.header_data.billing_document_type : ''});
            this.setState({documentDate: result.header_data.document_date ? result.header_data.document_date : ''});
            this.setState({totalAmount: result.header_data.total_amount ? result.header_data.total_amount : ''});
            this.setState({currencyKey: result.header_data.currency_key ? result.header_data.currency_key : ''});
          }
          if (result.partner_data) {
            const customer = result.partner_data.filter(obj => obj.partner_function === 'WE'); //TODO this should be configurable.
            const invoiceRecipient = result.partner_data.filter(obj => obj.partner_function === 'RG');
            this.setState({customerAddress: customer[0].address_data});
            this.setState({invoiceRecipientAddress: invoiceRecipient[0].address_data});
          }
          if (result.item_data) {
            this.setState({itemData: result.item_data});
          }
        }
      }).catch(() => { /* TODO: Catch error */
      });
    }
  }

  formatHeaderDate(headerDate) {
    const format = 'MM/DD/YYYY';
    const localeDate = moment(headerDate, format);
    return localeDate.format(format);
  }

  getInvoice() {
  }

  render() {

    const {
      customerAddress,
      invoiceRecipientAddress,
      billingDocumentNumber,
      billingDocumentType,
      documentDate,
      itemData,
      totalAmount,
      currencyKey,
      backPage,
    } = this.state;
    let headerDate = documentDate ? this.formatHeaderDate(documentDate) : '';
    const docNumber = billingDocumentNumber ? removePreceedingZero(billingDocumentNumber) : '';
    const customerCity = customerAddress ? customerAddress.city : '';
    const customerRegion = customerAddress ? customerAddress.region : '';
    const customerPostalCode = customerAddress ? customerAddress.postal_code_city : '';

    const invoiceRecipientCity = invoiceRecipientAddress ? invoiceRecipientAddress.city : '';
    const invoiceRecipientRegion = invoiceRecipientAddress ? invoiceRecipientAddress.region : '';
    const invoiceRecipientCode = invoiceRecipientAddress ? invoiceRecipientAddress.postal_code_city : '';
    const currencySymbol = getCurrency(currencyKey);

    let invoice = this.props.invoices.find(i => trimLeadingZeroes(i.billing_document_number) === trimLeadingZeroes(docNumber));
    let showDetail = this.state.itemData !== null;
    let allowPay = false;
    let _isCredit = false;
    if (invoice && invoice.zzcustom && invoice.zzcustom.nodetail === "X") {
      showDetail = false;

    }
    if (invoice) {
      allowPay = this.props.canMakePayment && !isCredit(invoice);
      _isCredit = isCredit(invoice);
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col justify-content-between d-flex">
            <div>
              <button className="btn button-back" onClick={this.goBack}>
                <FontAwesomeIcon icon={faAngleLeft} className={"button-back-text"}/> &nbsp;
                <span className="button-back-text">Back to Invoices</span>
              </button>
            </div>
            <div>
              {invoice && allowPay && <button className="btn btn-primary btn-lg" onClick={() => {
                this.pay(invoice)
              }}>
                <span className="button-back-text"><strong>Pay This Invoice</strong></span>
              </button>}
            </div>
          </div>
        </div>
        <br/>
        <div className="row align-items-center justify-content-center">
          <span className="invoiceNumber">{`${'Invoice'}${' '}${docNumber}`}</span>
        </div>
        <br/>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 col-12 topPadding">
            <div className="row">
              <span
                className="col-sm-12 col-12 col-form-label text-secondary font-weight-bold nopadding">Customer</span>
              <span className="col-form-label col-form-label-sm text-secondary nopadding">{customerAddress.name}</span>
            </div>
            <div className="row">
              <span
                className="col-form-label col-form-label-sm text-secondary nopadding">{customerAddress.street}</span>
            </div>
            <div className="row">
              <span
                className="col-form-label col-form-label-sm text-secondary nopadding">{`${customerCity}${' '}${customerRegion}${' '}${customerPostalCode}`}</span>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 col-12 topPadding">
            <div className="row">
              <span className="col-sm-12 col-12 col-form-label text-secondary font-weight-bold nopadding">Invoice Recipient</span>
              <span
                className="col-form-label col-form-label-sm text-secondary nopadding">{invoiceRecipientAddress.name}</span>
            </div>
            <div className="row">
              <span
                className="col-form-label col-form-label-sm text-secondary nopadding">{invoiceRecipientAddress.street}</span>
            </div>
            <div className="row">
              <span
                className="col-form-label col-form-label-sm text-secondary nopadding">{`${invoiceRecipientCity}${' '}${invoiceRecipientRegion}${' '}${invoiceRecipientCode}`}</span>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 col-12 topPadding">
            <div className="row">
              <span
                className="col-md-2 col-sm-2 col-2 col-form-label text-secondary font-weight-bold nopadding">Date</span>
              <span
                className="col-md-10 col-sm-10 col-10 col-form-label col-form-label-sm text-secondary nopadding">{headerDate}</span>
            </div>
            <div className="row">
              <span className="col-sm-12 col-12">&nbsp;</span>
            </div>
            <div className="row">
              <span className="col-sm-12 col-12">&nbsp;</span>
            </div>
          </div>
        </div>
        <br/>
        <br/>
        {showDetail && <div className="row">
          <div className={"col-12"}>
            <BootstrapTable data={itemData}
                            tableHeaderClass={"cnbs-details-table"}
                            tableContainerClass={'wa-bootstrap-table-container custom-table-header'}>
              <TableHeaderColumn width="65" className="headerColumnColor" dataAlign="left" dataField="item_number"
                                 dataFormat={formatColumn} isKey>
                Item
              </TableHeaderColumn>
              <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="left" dataField="billed_quantity"
                                 dataFormat={formatColumn}>
                Qty
              </TableHeaderColumn>
              <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="left" dataField="material_number"
                                 dataFormat={formatColumn}>
                Article #
              </TableHeaderColumn>
              <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="left" dataField="description"
                                 dataFormat={formatColumn}>
                Description
              </TableHeaderColumn>
              <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="right" dataField="total_amount"
                                 dataFormat={calculateUnitPrice}>
                Unit Price
              </TableHeaderColumn>
              <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="right" dataField="total_amount"
                                 dataFormat={formatTotal}>
                Total
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
        }
        <div className="row">
          <div className={"d-flex col-12 justify-content-end"}>
            <span className="invoiceTotalLabel">{`${'Invoice Total: '}`}</span>
            &nbsp;
            <span className="invoiceTotalValue">{`${currencySymbol}${formatMoney(totalAmount)}`}</span>
          </div>
        </div>
      </div>
    );
  }
}

Detail.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default withRouter(connect((state, props) => ({
  invoices: state.default.invoices,
  canMakePayment: canMakePayment(state, props)
}))(Detail));
